import { absoluteUrl } from "@rallly/utils/absolute-url";

export const DEFAULT_PRIMARY_COLOR = "#C9A962";
// Dark-mode primary buttons render at bg-primary/80 (~#a58b53 on gray-900), where the
// auto-derived white foreground is only 3.27:1 (WCAG AA fail). Ink is >=5:1 there.
export const DEFAULT_PRIMARY_DARK_FOREGROUND = "#1E201F";
export const DEFAULT_LOGO_URL = absoluteUrl("/static/logo.svg");
export const DEFAULT_LOGO_URL_DARK = absoluteUrl("/static/logo-dark.svg");
export const DEFAULT_LOGO_ICON_URL = absoluteUrl(
  "/images/rallly-logo-mark.png",
);
export const DEFAULT_APP_NAME = "ZenCleanz Meet";
export const LIGHT_MODE_BACKGROUND = "#ffffff";
export const DARK_MODE_BACKGROUND = "#171717";
